import React from "react";
import { Translate } from "react-redux-i18n";
import TranslatedPage from "../../containers/TranslatedPage";
import coBuyPoster from "../../styles/images/cobuy-poster.jpg";
import coBuyVideo from "../../styles/images/ihopa-cobuy-video.mp4";

export default function CoBuying({ isPrypool }) {
  return (
    <section>
      <div className="main-container">
        <div className="content-wrapper">
          <div className="landing-box-feature co-buying">
            <div className="landing-box-copy">
              <h4>
                <TranslatedPage path="home.content_blocks.landing_co_buy.subheading" />
              </h4>
              <h1>
                <TranslatedPage path="home.content_blocks.landing_co_buy.heading" />
              </h1>
              <div className="mobile-landing-box-illustration">
                {/* <img src={coBuyingPlaceholder} alt="ihopa Co-buying"/> */}
                <video
                  className="cobuy-video"
                  loop
                  autoPlay
                  muted
                  playsInline
                  controls={false}
                  poster={coBuyPoster}
                >
                  <source src={coBuyVideo} type="video/mp4" />
                </video>
              </div>
              <div className="landing-box-content">
                <TranslatedPage path="home.content_blocks.landing_co_buy.content" />
              </div>
              <div className="landing-box-buttons">
                {/* <Button
                                    className="cta"
                                    intent="primary"
                                    text={I18n.t("home.co_buy.button_text")}
                                /> */}
                {isPrypool && (
                  <>
                    <a
                      href="/agodela#start-co-owning"
                      className="bp3-button bp3-intent-primary cta"
                    >
                      <strong>
                        <Translate value="home.co_buy.button_text" />
                      </strong>
                    </a>
                  </>
                )}
                {!isPrypool && (
                  <>
                    <a
                      href="#start-co-owning"
                      className="bp3-button bp3-intent-primary cta"
                    >
                      <strong>
                        <Translate value="home.co_buy.button_text" />
                      </strong>
                    </a>
                    <a href="#how-it-works" className="learn-more-link">
                      <strong>
                        <Translate value="home.hero.learn_more" />
                      </strong>
                    </a>
                  </>
                )}
              </div>
            </div>
            <div className="landing-box-illustration">
              {/* <img src={coBuyingPlaceholder} alt="ihopa Co-buying"/> */}
              <video
                className="cobuy-video"
                loop
                autoPlay
                muted
                playsInline
                controls={false}
                poster={coBuyPoster}
              >
                <source src={coBuyVideo} type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
